import { useMemo } from 'react';
import {withStore} from '@stores';
import {observer} from 'mobx-react-lite';
import clsx from 'clsx';

import {
  AcIsSet,
  AcIsArray,
  AcPagination,
} from '@opp/ui-kit';

import {
  AcContainer,
  AcRow,
  AcColumn,
  AcLoaderInline,
  AcEmptyBlock,
} from '@opp/ui-kit';
import AcSettlementsList from '@components/ac-settlements-list/ac-settlements-list';
import {useTranslation, withTranslation} from "react-i18next";
import { useSettlementsParams } from '@src/views/ac-settlements-overview/ac-settlements-overview';
import { useGetSettlementsQuery } from '@src/api/openapi/merchantApi';

const _CLASSES = {
  MAIN: 'ac-settlements-overview-all-tab',
};

const AcSettlementOverviewAllTab = () => {
  const {t} = useTranslation();
  const {values: {date, order, filter, page}, operations} = useSettlementsParams();
  const {data = {}, isFetching: isLoading} = useGetSettlementsQuery({dateStart: date, order, status: filter, page});
  const settlements = data.data;
  const meta = data.meta;

  const handlePagination = (_: unknown, num: number) => {
    const $scroller = document.querySelector('#ac-scroller');
    if ($scroller) {
      $scroller.scrollTop = 0;
    }

    if (AcIsSet(num)) {
      operations.setQuery({page: num});
    }

  };

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  });

  const renderSettlements = useMemo(() => {
    if (isLoading) {
      return <AcLoaderInline loading />;
    }

    if (
      !AcIsSet(settlements) ||
            !AcIsArray(settlements) ||
            settlements.length === 0
    ) {
      return <AcEmptyBlock message={t('no-settlements-found', 'No settlements found to display', {ns: 'payouts'})} />;
    }

    return <AcSettlementsList items={settlements} />;
  }, [settlements, isLoading]);

  const renderPagination = useMemo(() => {
    if (isLoading) {
      return null;
    }

    if (
      !AcIsSet(settlements) ||
            !AcIsArray(settlements) ||
            settlements.length === 0
    ) {
      return null;
    }

    const options = {
      total_pages: Math.ceil(meta.total / meta.per_page),
      callback: handlePagination,
      total_count: meta.total,
      from: meta.from,
      to: meta.to,
      showFromTo: true,
      ...meta,
    };

    return <AcPagination
      {...options} />;
  }, [settlements, meta, isLoading]);

  return (
    <div className={getMainClassNames}>
      <AcContainer fluid>
        <AcRow>
          <AcColumn xs={12}>{renderSettlements}</AcColumn>
        </AcRow>

        <AcRow className={'h-padding-bottom-50'}>
          <AcColumn xs={12}>{renderPagination}</AcColumn>
        </AcRow>
      </AcContainer>
    </div>
  );
};

export default withTranslation(['payouts', 'pagination', 'store'])(withStore(observer(AcSettlementOverviewAllTab)));
